<template>
  <div>
    <div id="dashboard" class="dashboard-container">
      <v-container fluid class="pa-0 px-4 pt-4">
        <v-row>
          <!-- Guide Card -->
          <v-col cols="12" md="6">
            <div class="dash-card guide-card">
              <div class="dash-card-header guide-header" @click="loadPage()" style="cursor:pointer;">
                <div class="dash-header-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                  </svg>
                </div>
                <span class="dash-header-title">{{ $t('dashboard.guide') }}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="dash-header-arrow">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </div>
              <div class="dash-card-body">
                <div
                  v-for="item in wizardItems"
                  :key="item.id"
                  class="dash-item"
                  @click="loadPageHandler(item.id)"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="dash-item-icon">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                  <span>{{ item.wizardcode }}</span>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Alert Card -->
          <v-col cols="12" md="6">
            <div class="dash-card alert-card">
              <div class="dash-card-header alert-header" @click="loadAlert()" style="cursor:pointer;">
                <div class="dash-header-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                  </svg>
                </div>
                <span class="dash-header-title">{{ $t('alert') }}</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="dash-header-arrow">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </div>
              <div class="dash-card-body">
                <div
                  v-for="item in alertItems"
                  :key="item.id"
                  class="dash-item alert-item"
                  @click="loadAlertHandler(item.id)"
                >
                  <span class="alert-badge" :class="item.length > 0 ? 'badge-active' : 'badge-zero'">{{ item.length }}</span>
                  <span>{{ item.alerttype }}</span>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <div v-if="isErr">
        <app-error v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }" v-on:closeError="isErr = $event" />
      </div>

      <!-- Overlay -->
      <div v-if="showOverlay" class="overlay">
        <div class="overlay-content">
          <h2 class="pb-3">{{ acknowledgement.longdesc }}</h2>
          <h4 class="pb-3"> Published on: {{ acknowledgement.publishDate }} </h4>
          <div class="terms-scroll">
            <div v-html="acknowledgement.content"></div>
          </div>
          <div class="button-row">
            <button class="ack-btn" @click="acceptAcknowledge">Acknowledge</button>
            <button class="cancel-btn" @click="logoutHandler">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../../components/common/ErrorDialog";
import moment from "moment";

export default {
  components: {
    "app-error": ErrorDialog,
  },
  data() {
    return {
      getid: this.$route.params.id,
      getpanel: this.$route.params.panel,
      formData: {
        wizardcode: null,
        wizarddesc: null,
        alerttype: null,
        alerttypeid: null,
        length: null,
        userid: this.$store.getters.userId,
      },

      wizardItems: [],
      alertItems: [],

      dataItemsDueconfirm: [],
      dataItemsExtendedDueconfirm: [],
      dataItemsDuecessation: [],
      dataItemsDuecontract: [],
      dataItemsDuedocument: [],
      dataItemsDuebirthday: [],
      dataItemsDuework3years: [],
      dataItemsDuework5years: [],
      dataItemsDuework10years: [],

      isErr: false,
      errMsg: "",

      // Acknowledgement 
      showOverlay: false,
      acknowledgement: {
        id: null,
        longdesc: null,
        content: null,
        publishDate: null,
      },

      acknowledgementAcceptance: {  //new acknowledgement acceptance record
        ackRecordId: null,
        staffId: null,
        companyId: null,
        psnId: this.$store.getters.psnId,
        userId: this.$store.getters.userId,
        acknowledgementDateTime: null,
        stamp: 0,
        updatedby: this.$store.getters.userId
      },
    };
  },
  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    loadWizardList() {
      const vm = this;

      this.$store.dispatch('get', {
        url: "/wizardsetup/all"
      })
        .then((res) => {
          vm.wizardItems = res.data.rec;
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

    loadPageHandler(id) {
      let wizard = this.getid;
      this.$router.push({ name: "wizardstep", params: { id, wizard } });
    },

    getDueconfirmdateHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/dueconfirmdate/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDueconfirm = res.data.rec;

          vm.alertItems.push({
            id: 1,
            alerttype: this.$t('reporalertlisting.dueforconfirmationdate'),
            length: res.data.rec.length,
          });
          this.getExtendedDueconfirmdateHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getExtendedDueconfirmdateHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/exdueconfirmdate/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsExtendedDueconfirm = res.data.rec;

          vm.alertItems.push({
            id: 2,
            alerttype: this.$t('reporalertlisting.dueextendedconfirmationdate'),
            length: res.data.rec.length,
          });
          this.getDuecessationdateHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuecessationdateHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duecessationdate/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuecessation = res.data.rec;

          vm.alertItems.push({
            id: 3,
            alerttype: this.$t('reporalertlisting.dueforcessationdate'),
            length: res.data.rec.length,
          });
          this.getDuecontractexpiryHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuecontractexpiryHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duecontractexpiry/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuecontract = res.data.rec;

          vm.alertItems.push({
            id: 4,
            alerttype: this.$t('reporalertlisting.dueforcontractexpiry'),
            length: res.data.rec.length,
          });
          this.getDuedocumentexpiryHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuedocumentexpiryHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duedocumentexpiry/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuedocument = res.data.rec;

          vm.alertItems.push({
            id: 5,
            alerttype: this.$t('reporalertlisting.duefordocexpiry'),
            length: res.data.rec.length,
          });
          this.getDuebirthdayHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuebirthdayHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duebirthday/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuebirthday = res.data.rec;

          vm.alertItems.push({
            id: 6,
            alerttype: this.$t('reporalertlisting.duefordob'),
            length: res.data.rec.length,
          });
          this.getDuework3yearsHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuework3yearsHandler() {
      const vm = this;

      this.$store.dispatch('get', {
        url: `/duework3years/all/${this.$store.getters.userId}`
      })
        .then((res) => {
          vm.dataItemsDuework3years = res.data.rec;

          vm.alertItems.push({
            id: 7,
            alerttype: this.$t('reporalertlisting.dueforwanthree'),
            length: res.data.rec.length,
          });
          this.getDuework5yearsHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuework5yearsHandler() {
      const vm = this;

      this.$store.dispatch('get', {
        url: `/duework5years/all/${this.$store.getters.userId}`
      })

        .then((res) => {
          vm.dataItemsDuework5years = res.data.rec;

          vm.alertItems.push({
            id: 8,
            alerttype: this.$t('reporalertlisting.dueforwanfive'),
            length: res.data.rec.length,
          });
          this.getDuework10yearsHandler();
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    getDuework10yearsHandler() {
      const vm = this;
      this.$store.dispatch('get', {
        url: `/duework10years/all/${this.$store.getters.userId}`
      })

        .then((res) => {
          vm.dataItemsDuework10years = res.data.rec;

          vm.alertItems.push({
            id: 9,
            alerttype: this.$t('reporalertlisting.dueforwanten'),
            length: res.data.rec.length,
          });

          console.log("alert8", vm.alertItems);
        })
        .catch((err) => {
          vm.errMsg = err;
        });
    },

    loadAlertHandler(panel) {
      let alert = this.getpanel;
      this.$router.push({ name: "alertlisting", params: { panel, alert } });
    },

    loadPage() {
      this.$router.push({ name: "wizardlisting" });
    },

    loadAlert() {
      this.$router.push({ name: "alertlisting" });
    },

    Loadacknowledgement() {
      this.$store.dispatch('get', {
        url: `/validAcknowledgement/${this.$store.getters.psnId}/${this.$store.getters.userId}`
      })
        .then((res) => {
          // console.log("ack", res.data.rec);
          // console.log("what is the res result", res.data, "Full res", res);

          // i should reconsider here for res.status thing
          if (res.data.status == 500 || res.data.status == 404) {
            this.isErr = true;
            this.errMsg = res.data.error;
          }
          else if (res.data.status == 200) {
            // Show Acknowledgement Overlay
            this.acknowledgement.id = res.data.rec.acknowledgement.id;
            this.acknowledgement.longdesc = res.data.rec.acknowledgement.ackLongDesc;
            this.acknowledgement.content = res.data.rec.acknowledgement.content;
            this.acknowledgement.publishDate = moment(res.data.rec.acknowledgement.publishDate).format("DD MMMM YYYY");
            // console.log("acknowledgement value", this.acknowledgement);

            //prepare new acknowledgement acceptance record, to save later
            this.acknowledgementAcceptance.ackRecordId = res.data.rec.acknowledgement.id;
            this.acknowledgementAcceptance.staffId = res.data.rec.staffId;
            this.acknowledgementAcceptance.companyId = res.data.rec.companyId;

            this.showOverlay = true;
          }
          else if (res.data.status == 204) {
            // No pending acknowledgement to show
            // console.log("No pending acknowledgement to show");
          }
          else {
            this.isErr = true;
            this.errMsg = "Unexpected response status while loading Acknowledgement: " + res.data.status;
            console.log("Unexpected response:", res.data);
          }
        })
        .catch((err) => {
          this.isErr = true;
          this.errMsg = err;
        });
    },

    acceptAcknowledge() {
      console.log("Acknowledge button clicked");
      console.log("now pass the acknowledgementAcceptance data", this.acknowledgementAcceptance);
      const vm = this;
      this.$store.dispatch('post', { url: "/acknowledgementacceptance/new", payload: this.acknowledgementAcceptance })
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            // const id = res.data.newInsertedId;
            // this.$router.push({ name: "acknowledgementedit", params: { id: id } });
            this.showOverlay = false;
            window.location.reload(); //reload page if there is another acknowledgement to show
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

    logoutHandler() {
      this.$router.replace("/" + this.$i18n.locale + "/home/" + this.$store.getters.db);
      this.$store.dispatch("deleteToken");
    },
  },

  mounted() {
    this.loadWizardList();

    this.getDueconfirmdateHandler();

    //console.log("staffid,", this.$store.getters.staffId, "and userid,", this.$store.getters.userId, "psnid", this.$store.getters.psnId);
    if (this.$store.getters.psnId) { // valid psnId
      this.Loadacknowledgement();
    }
    else {
      console.log("No valid psnId to load Acknowledgement");
    }
  },
};
</script>

<style>
/* Dashboard cards */
.dashboard-container {
  min-height: 80vh;
}

.dash-card {
  border-radius: 16px;
  border: 1px solid #E8EDF5;
  box-shadow: 0 2px 12px rgba(0,0,0,0.07);
  overflow: hidden;
  background: #fff;
  margin-bottom: 16px;
}

.dash-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 20px;
  font-weight: 700;
  font-size: 0.95rem;
  letter-spacing: normal;
  transition: opacity 0.15s;
}
.dash-card-header:hover { opacity: 0.9; }

.guide-header {
  background: linear-gradient(135deg, #4F6BFF 0%, #7C3AFF 100%);
  color: #fff;
}

.alert-header {
  background: linear-gradient(135deg, #7C3AFF 0%, #DB2777 100%);
  color: #fff;
}

.dash-header-icon {
  width: 32px; height: 32px;
  background: rgba(255,255,255,0.2);
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}

.dash-header-title { flex: 1; }

.dash-header-arrow { opacity: 0.7; flex-shrink: 0; }

.dash-card-body {
  padding: 8px 0 4px 0;
}

.dash-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  font-size: 0.82rem;
  color: #1a3a5c;
  letter-spacing: normal;
  cursor: pointer;
  border-bottom: 1px solid #F1F5F9;
  transition: background 0.12s;
}
.dash-item:last-child { border-bottom: none; }
.dash-item:hover { background: #F8FAFF; }

.dash-item-icon { color: #4F6BFF; flex-shrink: 0; }

.alert-item { color: #37474f; }

.alert-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  border-radius: 11px;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 0 6px;
  flex-shrink: 0;
}
.badge-active { background: #FEE2E2; color: #DC2626; }
.badge-zero { background: #F1F5F9; color: #94A3B8; }

/* Overlay */
.overlay {
  position: fixed; top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.7);
  display: flex; align-items: center; justify-content: center;
  z-index: 9999;
}
.overlay-content {
  background: white; width: 80%; height: 80%; max-height: 80%;
  padding: 20px; border-radius: 10px;
  display: flex; flex-direction: column;
}
.terms-scroll {
  flex: 1; overflow-y: auto; overflow-x: auto;
  margin-bottom: 20px; padding: 15px;
  border: 1px solid #ccc; border-radius: 6px;
  background: #fafafa; line-height: 1.6; color: #333;
}
.ack-btn {
  align-self: center; padding: 12px 28px;
  background-color: #28a745; color: white;
  font-weight: 600; font-size: 16px; border: none;
  border-radius: 6px; cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.ack-btn:hover { background-color: #218838; transform: translateY(-1px); }
.button-row { display: flex; justify-content: center; gap: 20px; margin-top: 20px; }
.cancel-btn {
  padding: 12px 28px; background-color: #ffc107; color: #fff;
  font-weight: 600; font-size: 16px; border: none; border-radius: 6px; cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.cancel-btn:hover { background-color: #e0a800; transform: translateY(-1px); }
</style>